// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vec-tag-button__Tag-module--Dh90m {
    appearance: none;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    font: inherit;
    line-height: normal;
    display: inline-flex;
    align-items: center;
}
`, "",{"version":3,"sources":["webpack://./vector/src/Tag/Tag.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;AACvB","sourcesContent":[".vec-tag-button {\n    appearance: none;\n    background: none;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n    font: inherit;\n    line-height: normal;\n    display: inline-flex;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"vecTagButton": `vec-tag-button__Tag-module--Dh90m`
};
export default ___CSS_LOADER_EXPORT___;
